import { fromJS } from 'immutable';

import {
  LOAD_SENDBIRD_USER,
  LOAD_SENDBIRD_USER_SUCCESS,
  LOAD_SENDBIRD_USER_ERROR,
  LOAD_SENDBIRD_CHANNEL,
  LOAD_SENDBIRD_CHANNEL_SUCCESS,
  LOAD_SENDBIRD_CHANNEL_ERROR,
  SET_SENDBIRD_CHANNEL_URL,
  SET_MESSAGE_LIST_QUERY,
  CLEAR_SENDBIRD_DATA,
} from '../constants/sendbird';


const initialState = fromJS({
  sendbirdUser: null,
  loading: false,
  error: null,
  sendbirdChannelURL: null,
  sendbirdChannel: null,
  channelLoading: false,
  channelError: null,
  messageListQuery: null,
});

function sendbirdReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_SENDBIRD_USER:
    return state
      .set('sendbirdUser', null)
      .set('loading', true);
  case LOAD_SENDBIRD_USER_SUCCESS:
    return state
      .set('sendbirdUser', action.sendbirdUser)
      .set('loading', false);
  case LOAD_SENDBIRD_USER_ERROR:
    return state
      .set('sendbirdUser', null)
      .set('loading', false)
      .set('error', action.error);
  case LOAD_SENDBIRD_CHANNEL:
    return state
      .set('sendbirdChannel', null)
      .set('channelLoading', true)
      .set('channelError', null);
  case LOAD_SENDBIRD_CHANNEL_SUCCESS:
    return state
      .set('sendbirdChannel', action.sendbirdChannel)
      .set('channelLoading', false);
  case LOAD_SENDBIRD_CHANNEL_ERROR:
    return state
      .set('sendbirdChannel', null)
      .set('channelLoading', false)
      .set('channelError', action.error);
  case SET_SENDBIRD_CHANNEL_URL:
    return state
      .set('sendbirdChannelURL', action.sendbirdChannelURL);
  case SET_MESSAGE_LIST_QUERY:
    return state
      .set('messageListQuery', action.messageListQuery);
  case CLEAR_SENDBIRD_DATA:
    return state
      .set('sendbirdChannelURL', null)
      .set('sendbirdChannel', null)
      .set('channelLoading', false)
      .set('channelError', null)
      .set('messageListQuery', null);
  default:
    return state;
  }
}

export default sendbirdReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/sendbird.js
 **/